import { ValueError } from "../error/ValueError.js";
import { isObject } from "./object.js";
/**
 * Recurse through `Sourceable` objects and return the first one that is an instance of `type`, or `null` if no source object matches.
 */
export function getOptionalSource(type, value) {
    if (isObject(value)) {
        if (value instanceof type)
            return value;
        if ("source" in value)
            return getOptionalSource(type, value.source);
    }
}
/**
 * Recurse through `Sourceable` objects and return the first one that is an instance of `type`.
 */
export function getSource(type, data) {
    const source = getOptionalSource(type, data);
    if (!source)
        throw new ValueError(`Source "${type.name}" not found`, data);
    return source;
}
